/* CHiATO Coffee Plan — landing interactivity + box picker.
 * Dev build (theme 209325818187).
 * Catalog: real products rendered by snippets/coffee-plan-catalog.liquid into window.CoffeePlanCatalog
 * (format code `code` = beans | nesp | dg and `slots` come from collection + coffee.plan_slots, never from
 * translated text). Box picker strings: window.CoffeePlanStrings (snippets/coffee-plan-box-strings.liquid).
 * Image keys resolve through window.CoffeePlanImg (filled by Liquid via file_url); catalog items carry full URLs.
 */
(function () {
  'use strict';

  var IMG = window.CoffeePlanImg || {};
  function img(key) { return IMG[key] || (/^(https?:)?\/\//.test(String(key || '')) ? key : ''); }

  var CATALOG = window.CoffeePlanCatalog || [];
  var S = window.CoffeePlanStrings || {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* i18n: S[key] with __name__ sentinels replaced; plural picks <key>One / <key>Other by n. */
  function tr(key, vars) {
    var s = S[key] == null ? '' : String(S[key]);
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('__' + k + '__').join(vars[k]); });
    return s;
  }
  function trn(key, n, vars) { var v = vars || {}; v.n = n; return tr(key + (n === 1 ? 'One' : 'Other'), v); }
  /* money: the theme's one formatter (layout/theme.liquid, CHiATO_formatMoney), cents in.
     Round 10 deleted eur(), which always prefixed the symbol, grouped thousands with spaces
     and dropped decimals - a format that belongs to EUR alone - and made the receipt's JS
     numbers change shape after load. The fallback names the active currency by ISO code. */
  function money(cents) {
    if (typeof window.CHiATO_formatMoney === 'function') return window.CHiATO_formatMoney(cents);
    return (Number(cents) / 100).toFixed(2) + ' ' + ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '');
  }
  function moneyShort(cents) { return money(cents).replace(/[.,]00(?=\D*$)/, ''); }
  function codeOf(c) { return c.code || (c.fmt === 'Beans' ? 'beans' : String(c.fmt).indexOf('Nespresso') === 0 ? 'nesp' : 'dg'); }
  function slotSize(c) { return Number(c.slots) || (codeOf(c) === 'beans' ? 6 : 1); }
  function dots(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<i class="' + (i <= n ? 'f' : '') + '"></i>'; return '<span class="cp-dots">' + s + '</span>'; }
  function byId(id) { for (var i = 0; i < CATALOG.length; i++) if (CATALOG[i].id === id) return CATALOG[i]; return null; }
  function readPlan() {
    var m = (location.search + ' ' + decodeURIComponent(location.hash || '')).match(/plan=(PLAY\+|PLAY%2B|PLAY)/i);
    if (!m) return null;
    return /\+|%2B/.test(m[1]) ? 'PLAY+' : 'PLAY';
  }

  /* ---------------- LANDING ---------------- */
  function initLanding(root) {
    /* data-cup-price is rendered only when this currency has comparison figures (round 10).
       Without it there is no receipt, and the calculator must not invent a café price. */
    var cupPrice = parseFloat(root.getAttribute('data-cup-price'));
    var planMonthly = parseFloat(root.getAttribute('data-play-price'));
    var hasMoney = cupPrice > 0 && planMonthly > 0;
    var state = { cups: 1, box: 'beans' };
    /* strings from sections/coffee-plan-landing.liquid (window.CoffeePlanLandingStrings); EN fallback if missing */
    var LS_EN = {
      cupsPhrase: { one: '__n__ café coffee', other: '__n__ café coffees' }, plusTagHouseholds: 'For households', plusTagRecommended: 'Recommended for you',
      demoBagTag: '__name__ · 1 kg · fills all 6 slots',
      demoBeansText: 'One bag of Belgique. About 120 cups.', demoBeansSub: 'Grind fresh every morning',
      demoCapsText: 'Six boxes of capsules, four blends. About 70 cups.', demoCapsSub: 'Nespresso® and Dolce Gusto® in one box',
      demoMixText: 'Five boxes picked, one slot still free.', demoMixSub: 'The picker tells you what still fits'
    };
    var LS = window.CoffeePlanLandingStrings || {};
    function ls(k) { return LS[k] != null ? String(LS[k]) : LS_EN[k]; }
    /* Plural noun phrase in the shopper's language: CLDR forms from the locale, picked by CHiATO_plural */
    function cupsPhrase(n) {
      var forms = LS.cupsPhrase || LS_EN.cupsPhrase;
      if (window.CHiATO_plural) return window.CHiATO_plural(n, forms);
      return String(n === 1 ? forms.one : forms.other).replace('__n__', n);
    }

    function render() {
      var cupsYear = state.cups * 5 * 52;
      var yearly = Math.round(cupsYear * cupPrice);
      var planYear = planMonthly * 12;
      var vals = {
        cups: state.cups, cupsPhrase: cupsPhrase(state.cups), cupsYear: cupsYear,
        yearly: hasMoney ? moneyShort(yearly * 100) : null, planYear: hasMoney ? moneyShort(Math.round(planYear * 100)) : null,
        saved: hasMoney ? moneyShort((yearly - planYear) * 100) : null,
        hours: Math.round(cupsYear * 6 / 60),
        recName: state.cups < 3 ? 'PLAY' : 'PLAY+',
        plusTagText: state.cups < 3 ? ls('plusTagHouseholds') : ls('plusTagRecommended')
      };
      root.querySelectorAll('[data-cp]').forEach(function (el) { var k = el.getAttribute('data-cp'); if (k in vals && vals[k] != null) el.textContent = vals[k]; });
      root.querySelectorAll('[data-cp-cups]').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-cp-cups') === state.cups); });
      root.querySelectorAll('[data-cp-box]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-cp-box') === state.box); });
      var playCard = root.querySelector('[data-cp-plan="PLAY"]'), plusCard = root.querySelector('[data-cp-plan="PLAY+"]');
      if (playCard && plusCard) {
        var rec = state.cups < 3;
        playCard.classList.toggle('rec', rec); plusCard.classList.toggle('rec', !rec);
        var t = playCard.querySelector('.cp-plan__tag'); if (t) t.classList.toggle('show', rec);
        [[playCard, rec], [plusCard, !rec]].forEach(function (p) {
          var a = p[0].querySelector('[data-cp-plan-cta]'); if (!a) return;
          a.classList.toggle('btn-primary', p[1]); a.classList.toggle('btn-secondary', !p[1]);
        });
      }
      renderDemo();
    }
    function renderDemo() {
      var tray = root.querySelector('[data-cp-tray]'); if (!tray) return;
      var text = root.querySelector('[data-cp-demo-text]'), sub = root.querySelector('[data-cp-demo-sub]');
      var slots, t, s;
      if (state.box === 'beans') { slots = [{ bag: true, img: 'plan-belgique-1kg', tag: ls('demoBagTag').split('__name__').join('Belgique') }]; t = ls('demoBeansText'); s = ls('demoBeansSub'); }
      else if (state.box === 'caps') { slots = [['plan-nesp-belgique','Belgique'],['plan-nesp-belgique','Belgique'],['plan-nesp-royale','Royale'],['plan-nesp-intenso','Intenso'],['plan-dg-lungo','Lungo'],['plan-dg-cafeaulait','Café au Lait']].map(function (x) { return { img: x[0], tag: x[1] }; }); t = ls('demoCapsText'); s = ls('demoCapsSub'); }
      else { slots = [['plan-nesp-belgique','Belgique'],['plan-nesp-royale','Royale'],['plan-nesp-fragrante','Fragrante'],['plan-dg-cafeaulait','Café au Lait'],['plan-dg-lungo','Lungo']].map(function (x) { return { img: x[0], tag: x[1] }; }).concat([{ empty: true }]); t = ls('demoMixText'); s = ls('demoMixSub'); }
      tray.innerHTML = slots.map(function (x) {
        if (x.empty) return '<div class="cp-slot"></div>';
        return '<div class="cp-slot full' + (x.bag ? ' bag' : '') + '"><img src="' + esc(img(x.img)) + '" alt=""><small>' + esc(x.tag) + '</small></div>';
      }).join('');
      if (text) text.textContent = t; if (sub) sub.textContent = s;
    }
    var sticky = root.querySelector('.cp-sticky'), hero = root.querySelector('#top'), plans = root.querySelector('#plans');
    if (sticky && hero) {
      var onScroll = function () {
        var past = hero.getBoundingClientRect().bottom < 0;
        var atPlans = plans && plans.getBoundingClientRect().top < window.innerHeight && plans.getBoundingClientRect().bottom > 0;
        sticky.classList.toggle('show', past && !atPlans);
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cp-cups]'); if (c) { state.cups = +c.getAttribute('data-cp-cups'); render(); return; }
      var b = e.target.closest('[data-cp-box]'); if (b) { state.box = b.getAttribute('data-cp-box'); render(); }
    });
    render();
  }

  /* ---------------- BOX PICKER ---------------- */
  function initBox(root) {
    var nextBase = root.getAttribute('data-next-url') || '/cart';
    var variantIds = { 'PLAY': root.getAttribute('data-play-variant') || '', 'PLAY+': root.getAttribute('data-plus-variant') || '' };
    var sellingPlan = root.getAttribute('data-selling-plan') || '';
    /* prices in cents of the active currency (real plan variant prices, rendered by Liquid) */
    var prices = {
      'PLAY': parseInt(root.getAttribute('data-play-cents'), 10) || Math.round((parseFloat(root.getAttribute('data-play-price')) || 49) * 100),
      'PLAY+': parseInt(root.getAttribute('data-plus-cents'), 10) || Math.round((parseFloat(root.getAttribute('data-plus-price')) || 79) * 100)
    };
    /* first-box default: a real product id (data-default-item), else the first 1 kg bag in the catalog */
    var defaultId = root.getAttribute('data-default-item') || '';
    if (!byId(defaultId)) { var firstBag = CATALOG.filter(function (c) { return slotSize(c) === 6; })[0]; defaultId = firstBag ? firstBag.id : ''; }
    function defaultQty() { var q = {}; if (defaultId) q[defaultId] = 1; return q; }
    var state = { plan: readPlan() || root.getAttribute('data-default-plan') || 'PLAY', qty: defaultQty(), tab: 'beans', modal: null };
    try {
      var saved = JSON.parse(sessionStorage.getItem('coffeePlanBox') || 'null');
      if (saved && saved.plan === state.plan && saved.qty) {
        /* drop ids that are no longer in the catalog (e.g. the old test catalog) and overfull boxes */
        var clean = {}, usedS = 0;
        Object.keys(saved.qty).forEach(function (id) { var c = byId(id), q = parseInt(saved.qty[id], 10); if (c && q > 0) { clean[id] = q; usedS += q * slotSize(c); } });
        if (usedS > 0 && usedS <= (state.plan === 'PLAY+' ? 12 : 6)) state.qty = clean;
      }
    } catch (e) {}

    var el = {
      tray: root.querySelector('[data-cp-tray]'), minis: root.querySelector('[data-cp-minis]'), cards: root.querySelector('[data-cp-cards]'),
      tabs: root.querySelector('[data-cp-tabs]'), lines: root.querySelector('[data-cp-lines]'), modal: root.querySelector('[data-cp-modal]'),
      bar: root.querySelector('[data-cp-bar]')
    };

    function compute() {
      var plus = state.plan === 'PLAY+', total = plus ? 12 : 6;
      var used = 0, cupsTotal = 0;
      CATALOG.forEach(function (c) { var q = state.qty[c.id] || 0; used += q * slotSize(c); cupsTotal += q * c.cups; });
      return { plus: plus, total: total, used: used, left: total - used, cupsTotal: cupsTotal, full: total - used === 0, monthly: prices[state.plan] };
    }
    function setQty(id, n) { if (n <= 0) delete state.qty[id]; else state.qty[id] = n; render(); }
    function hasOtherBag(id) { return CATALOG.some(function (o) { return codeOf(o) === 'beans' && state.qty[o.id] && o.id !== id; }); }
    function decorate(c, m) {
      var q = state.qty[c.id] || 0, sz = slotSize(c), fits = sz <= m.left, isBean = sz === 6;
      var canSwap = isBean && !fits && hasOtherBag(c.id) && q === 0;
      var sents = String(c.desc || '').split('. ');
      return {
        q: q, fits: fits, isBean: isBean, canSwap: canSwap,
        qtyText: isBean ? trn('bags', q) : trn('boxes', q),
        label: fits ? (isBean ? tr('putBag') : tr('addOne')) : canSwap ? tr('swapBag') : (isBean ? tr('needsSix') : tr('boxFull')),
        pickCls: (fits || canSwap) ? (canSwap ? 'swap' : '') : 'dis',
        slotText: trn('slots', sz),
        cupsText: c.pair ? trn('drinks', c.cups) : trn('cups', c.cups),
        short: sents.slice(0, 2).join('. ') + (sents.length > 2 ? '.' : '')
      };
    }
    function plus(c) {
      var m = compute(), d = decorate(c, m);
      if (d.canSwap) {
        var removed = false;
        CATALOG.forEach(function (o) { if (!removed && codeOf(o) === 'beans' && state.qty[o.id]) { removed = true; state.qty[o.id] -= 1; if (state.qty[o.id] <= 0) delete state.qty[o.id]; } });
        state.qty[c.id] = 1; state.modal = null; render(); return;
      }
      if (!d.fits) return;
      setQty(c.id, d.q + 1);
    }

    function leftText(m) {
      if (m.full) return trn('leftFull', m.cupsTotal);
      if (m.left === m.total) return tr(m.plus ? 'leftEmptyPlus' : 'leftEmptyPlay', { n: m.total });
      if (m.left >= 6) return tr('leftBagOrCaps', { n: m.left });
      return trn('leftCaps', m.left);
    }

    function render() {
      var m = compute();
      try { sessionStorage.setItem('coffeePlanBox', JSON.stringify({ plan: state.plan, qty: state.qty })); } catch (e) {}

      /* header values */
      var vals = {
        planName: state.plan,
        monthly: String(m.monthly / 100).replace('.', ','),
        monthlyShort: moneyShort(m.monthly), monthlyFull: money(m.monthly),
        amountText: m.plus ? tr('amountPlus') : tr('amountPlay'),
        headline: m.plus ? tr('headlinePlus') : tr('headlinePlay'),
        rule: m.plus ? tr('rulePlus') : tr('rulePlay'),
        leftText: leftText(m),
        statusMark: m.full ? '✓' : tr('statusMark', { used: m.used, total: m.total }),
        statusText: m.full ? trn('statusFull', m.cupsTotal) : tr('statusFilled', { used: m.used, total: m.total }),
        fillText: tr('fillText', { used: m.used, total: m.total }),
        minLabel: tr('minLabel', { n: m.total }), contLabel: tr('contLabel', { price: moneyShort(m.monthly) })
      };
      root.querySelectorAll('[data-cp]').forEach(function (n) { var k = n.getAttribute('data-cp'); if (k in vals) n.textContent = vals[k]; });
      root.querySelectorAll('[data-cp-status]').forEach(function (n) { n.classList.toggle('full', m.full); });
      root.querySelectorAll('[data-cp-plan-pick]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-cp-plan-pick') === state.plan); });
      root.querySelectorAll('[data-cp-clear]').forEach(function (n) { n.hidden = m.used === 0; });
      root.querySelectorAll('[data-cp-ready]').forEach(function (n) { n.hidden = !m.full; });
      root.querySelectorAll('[data-cp-notready]').forEach(function (n) { n.hidden = m.full; });

      /* next url: carries plan + box (variant ids) as query; the real path is the cart add below */
      var items = []; CATALOG.forEach(function (c) { if (state.qty[c.id]) items.push((c.variant_id || c.id) + ':' + state.qty[c.id]); });
      var href = nextBase + (nextBase.indexOf('?') > -1 ? '&' : '?') + 'plan=' + encodeURIComponent(state.plan) + '&box=' + encodeURIComponent(items.join(','));
      root.querySelectorAll('[data-cp-next]').forEach(function (a) { a.setAttribute('href', href); });

      /* tray */
      var slots = [], minis = [];
      CATALOG.forEach(function (c) {
        var q = state.qty[c.id] || 0;
        for (var i = 0; i < q; i++) {
          var isBean = slotSize(c) === 6;
          slots.push('<div class="cp-slot full' + (isBean ? ' bag' : '') + '"><img src="' + esc(img(c.img)) + '" alt="' + esc(c.name) + '"><small>' + esc(tr(isBean ? 'trayBag' : 'trayItem', { name: c.name, size: c.size })) + '</small><button type="button" class="x" aria-label="' + esc(tr('remove')) + '" data-cp-remove="' + esc(c.id) + '">×</button></div>');
          if (isBean) { for (var k = 0; k < 6; k++) minis.push('<i class="bagpart ' + (k === 0 ? 'first' : k === 5 ? 'last' : 'mid') + '">' + (k === 2 ? '<img src="' + esc(img(c.img)) + '" alt="">' : '') + '</i>'); }
          else minis.push('<i class="full"><img src="' + esc(img(c.img)) + '" alt=""></i>');
        }
      });
      for (var k2 = 0; k2 < m.left; k2++) { slots.push('<div class="cp-slot"><span class="n">' + (m.used + k2 + 1) + '</span></div>'); minis.push('<i></i>'); }
      if (el.tray) el.tray.innerHTML = slots.join('');
      if (el.minis) el.minis.innerHTML = minis.join('');

      /* tabs */
      if (el.tabs) {
        var counts = { beans: 0, nesp: 0, dg: 0 };
        CATALOG.forEach(function (c) { counts[codeOf(c)]++; });
        el.tabs.querySelectorAll('[data-cp-tab]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-cp-tab') === state.tab); });
        var ct = root.querySelector('[data-cp-count]');
        if (ct) ct.textContent = state.tab === 'beans' ? trn('countBeans', counts.beans) : state.tab === 'nesp' ? trn('countNesp', counts.nesp) : trn('countDg', counts.dg);
      }

      /* cards */
      if (el.cards) {
        el.cards.innerHTML = CATALOG.map(function (c) {
          var d = decorate(c, m);
          var show = codeOf(c) === state.tab;
          if (!show) return '';
          var id = esc(c.id);
          var action = d.q > 0
            ? '<div class="cp-qty"><button type="button" aria-label="' + esc(tr('removeOne')) + '" data-cp-minus="' + id + '">−</button><span>' + esc(d.qtyText) + '</span><button type="button" aria-label="' + esc(tr('addOne')) + '" data-cp-plus="' + id + '" class="' + (d.fits ? '' : 'dis') + '">+</button></div>'
            : '<button type="button" class="cp-pick ' + d.pickCls + '" data-cp-plus="' + id + '">' + esc(d.label) + '</button>';
          return '<div class="cp-card' + (d.q > 0 ? ' on' : '') + '">' +
            '<div class="cp-card__img ' + esc(c.bg) + '" data-cp-open="' + id + '"><img src="' + esc(img(c.img)) + '" alt="' + esc(c.name) + '" loading="lazy"><span class="cp-fmt">' + esc(c.fmt) + '</span><span class="cp-slots">' + esc(d.slotText) + '</span><span class="cp-more">' + esc(tr('details')) + '</span></div>' +
            '<div class="cp-card__bd">' +
              '<div><span class="cp-eyebrow">' + esc(c.brand) + (c.tag ? ' · ' + esc(c.tag) : '') + '</span><h3 class="cp-h" data-cp-open="' + id + '">' + esc(c.name) + '<span> · ' + esc(c.size) + '</span></h3></div>' +
              '<div class="cp-notes">' + (c.notes || []).map(function (n) { return '<span class="cp-note">' + esc(n) + '</span>'; }).join('') + '</div>' +
              '<p class="cp-desc">' + esc(d.short) + '</p>' +
              '<div class="cp-meta"><span>' + esc(tr('strength')) + ' ' + dots(c.str) + '</span><b>' + esc(d.cupsText) + '</b></div>' +
              '<div class="cp-card__act">' + action + '</div>' +
            '</div></div>';
        }).join('');
      }

      /* summary lines */
      if (el.lines) {
        var lines = CATALOG.filter(function (c) { return state.qty[c.id]; }).map(function (c) {
          var cups = state.qty[c.id] * c.cups;
          return '<div class="cp-line"><img src="' + esc(img(c.img)) + '" alt=""><span>' + esc(tr('line', { qty: state.qty[c.id], name: c.name, size: c.size })) + '</span><b>' + esc(c.pair ? trn('drinks', cups) : trn('cups', cups)) + '</b></div>';
        });
        el.lines.innerHTML = lines.length ? lines.join('') : '<span class="cp-muted">' + esc(tr('linesEmpty')) + '</span>';
      }

      /* modal */
      if (el.modal) {
        var mc = state.modal ? byId(state.modal) : null;
        el.modal.hidden = !mc;
        document.body.classList.toggle('cp-modal-open', !!mc);
        if (mc) {
          var d2 = decorate(mc, m), mid = esc(mc.id);
          var act = d2.q > 0
            ? '<div class="cp-qty cp-qty--lg"><button type="button" aria-label="' + esc(tr('removeOne')) + '" data-cp-minus="' + mid + '">−</button><span>' + esc(d2.qtyText) + '</span><button type="button" aria-label="' + esc(tr('addOne')) + '" data-cp-plus="' + mid + '" class="' + (d2.fits ? '' : 'dis') + '">+</button></div>'
            : '<button type="button" class="cp-pick cp-pick--solid ' + d2.pickCls + '" data-cp-plus="' + mid + '">' + esc(d2.label) + '</button>';
          el.modal.querySelector('[data-cp-modal-body]').innerHTML =
            '<button type="button" class="cp-md__x" aria-label="' + esc(tr('close')) + '" data-cp-close>×</button>' +
            '<div class="cp-md__img ' + esc(mc.bg) + '"><img src="' + esc(img(mc.img)) + '" alt="' + esc(mc.name) + '"><span class="cp-fmt">' + esc(mc.fmt) + ' · ' + esc(mc.size) + '</span></div>' +
            '<div class="cp-md__body">' +
              '<div><span class="cp-eyebrow">' + esc(mc.brand) + '</span><h2 class="cp-h cp-md__title">' + esc(mc.name) + '</h2><span class="cp-md__tag">' + esc(mc.tag) + '</span></div>' +
              '<div class="cp-notes">' + (mc.notes || []).map(function (n) { return '<span class="cp-note">' + esc(n) + '</span>'; }).join('') + '</div>' +
              '<p class="cp-md__desc">' + esc(mc.desc) + '</p>' +
              '<div class="cp-kv"><span>' + esc(tr('mOrigin')) + '<b>' + esc(mc.origin) + '</b></span><span>' + esc(tr('mBeans')) + '<b>' + esc(mc.blend) + '</b></span><span>' + esc(tr('mRoast')) + '<b>' + esc(mc.roast) + '</b></span><span>' + esc(tr('mBestFor')) + '<b>' + esc(mc.best) + '</b></span><span>' + esc(tr('strength')) + '<b>' + dots(mc.str) + '</b></span><span>' + esc(tr('mInBox')) + '<b>' + esc(tr('mInBoxValue', { slots: d2.slotText, cups: d2.cupsText })) + '</b></span></div>' +
              '<div class="cp-md__act">' + act + '</div>' +
              '<span class="cp-muted">' + esc(tr('mFootnote')) + '</span>' +
            '</div>';
        }
      }
    }

    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-cp-plan-pick]'))) { state.plan = t.getAttribute('data-cp-plan-pick'); state.qty = defaultQty(); render(); return; }
      if ((t = e.target.closest('[data-cp-tab]'))) { state.tab = t.getAttribute('data-cp-tab'); render(); return; }
      if ((t = e.target.closest('[data-cp-plus]'))) { var c = byId(t.getAttribute('data-cp-plus')); if (c) plus(c); return; }
      if ((t = e.target.closest('[data-cp-minus]'))) { var id = t.getAttribute('data-cp-minus'); setQty(id, (state.qty[id] || 0) - 1); return; }
      if ((t = e.target.closest('[data-cp-remove]'))) { var id2 = t.getAttribute('data-cp-remove'); setQty(id2, (state.qty[id2] || 0) - 1); return; }
      if ((t = e.target.closest('[data-cp-clear]'))) { e.preventDefault(); state.qty = {}; render(); return; }
      if ((t = e.target.closest('[data-cp-open]'))) { state.modal = t.getAttribute('data-cp-open'); render(); return; }
      if ((t = e.target.closest('[data-cp-close]'))) { state.modal = null; render(); return; }
      if ((t = e.target.closest('[data-cp-next]'))) { if (variantIds[state.plan]) { e.preventDefault(); addToCart(t); } return; }
    });

    /* Cart add: one plan variant, box as line item properties.
     * Property NAMES are fixed English (ops/automation read them): Plan, Box, Cups, _box_json, _box_variants.
     * _box_json = [{ variant_id, sku, product_id, qty, slots }] — the warehouse picks by variant/SKU.
     * _box_variants = "variant_id:qty,..." (compact, same order). */
    function addToCart(btn) {
      var m = compute(); if (!m.full) return;
      var lines = [], json = [], vlist = [];
      CATALOG.forEach(function (c) {
        var q = state.qty[c.id]; if (!q) return;
        lines.push(c.name + ' ' + c.size + (c.sku ? ' [' + c.sku + ']' : '') + ' × ' + q);
        json.push({ variant_id: c.variant_id || null, sku: c.sku || '', product_id: c.product_id || null, qty: q, slots: slotSize(c) });
        vlist.push((c.variant_id || c.id) + ':' + q);
      });
      var props = { 'Plan': state.plan, 'Box': lines.join('; '), 'Cups': String(m.cupsTotal), '_box_json': JSON.stringify(json), '_box_variants': vlist.join(',') };
      var label = btn.innerHTML; btn.textContent = tr('adding'); btn.classList.add('cp-btn-dis');
      var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [Object.assign({ id: Number(variantIds[state.plan]), quantity: 1, properties: props }, sellingPlan ? { selling_plan: Number(sellingPlan) } : {})] }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            var err = new Error((res.j && (res.j.description || res.j.message)) || ('HTTP ' + res.status));
            /* 422 = Shopify refused the line: plan variant sold out, or not sold in this market.
               Branch on the STATUS only. err.message is Shopify's description, which Shopify
               localises - a regex on English words never matches on /da or /nl. */
            err.notAvailable = res.status === 422;
            throw err;
          }
          window.location.href = nextBase;
        })
        .catch(function (err) {
          btn.innerHTML = label; btn.classList.remove('cp-btn-dis');
          if (window.console) console.warn('[Coffee Plan] cart add failed:', err && err.message, '— is the Coffee Plan product active & published, and sold in this market?');
          var n = root.querySelector('[data-cp-error]');
          if (n) { n.textContent = err && err.notAvailable ? tr('errNotAvailable') : tr('errAddFailed'); n.hidden = false; }
        });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.modal) { state.modal = null; render(); } });
    render();
  }

  function boot() {
    document.querySelectorAll('[data-coffee-plan-landing]').forEach(initLanding);
    document.querySelectorAll('[data-coffee-plan-box]').forEach(initBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
